var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * 用户每个项数据组件
 */
import React, { useMemo, useCallback, useState } from 'react';
import { Input } from 'antd';
import { getIsSelf } from './common';
import { UserCardType } from './UserCardType';
import IconFont from '../IconFont';
function Remark(props) {
    var _this = this;
    var user = props.user, cardType = props.cardType, currentUser = props.currentUser, analysisLog = props.analysisLog, remarkSet = props.remarkSet;
    var _a = useState(user === null || user === void 0 ? void 0 : user.remark), remarkMsg = _a[0], setRemarkMsg = _a[1];
    var _b = useState(false), editing = _b[0], setEditing = _b[1];
    var textAreaChange = function (event) {
        var inputValue = event.target.value.trim() || '';
        setRemarkMsg(inputValue);
    };
    var onSaveTextArea = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setEditing(false);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, remarkSet(user, remarkMsg)];
                case 2:
                    _a.sent();
                    analysisLog === null || analysisLog === void 0 ? void 0 : analysisLog('xtbg_add_home_1637657110163', '78');
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('set remark error', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [analysisLog, remarkMsg, remarkSet, user]);
    var remarkNode = useMemo(function () {
        if (!remarkSet) {
            return remarkMsg;
        }
        if (!editing) {
            return (React.createElement("div", null,
                remarkMsg ? remarkMsg : React.createElement("span", { style: { color: 'rgba(129, 135, 147, 0.5)' } }, "\u6DFB\u52A0\u5907\u6CE8"),
                React.createElement(IconFont, { onClick: function () {
                        setEditing(true);
                    }, type: "iconbianji1", style: { color: "rgba(129, 135, 147, 1)", cursor: 'pointer', margin: '0 5px' } })));
        }
        return (React.createElement("div", { className: "remark-input-wrap" },
            React.createElement(Input, { style: {
                    border: 'none',
                    background: 'rgba(246,246,246,1)',
                    borderRadius: 4
                }, autoFocus: true, defaultValue: remarkMsg, value: remarkMsg, maxLength: 20, onChange: textAreaChange, onPressEnter: function () {
                    onSaveTextArea();
                }, onBlur: function () {
                    onSaveTextArea();
                } }),
            React.createElement("span", { style: {
                    color: '#1686FF',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    marginLeft: 5
                } }, "\u786E\u5B9A")));
    }, [editing, onSaveTextArea, remarkMsg, remarkSet]);
    if (cardType === UserCardType.Group || !user || getIsSelf(currentUser, user)) {
        return null;
    }
    // 没有备注，且没有定义设备备注的方法
    if (!remarkMsg && !remarkSet) {
        return null;
    }
    return (React.createElement("div", { className: "usercard-item-content" },
        React.createElement("h5", { className: "usercard-item-title" }, "\u5907\u6CE8"),
        React.createElement("p", { className: "usercard-item-desc remarkMsg-desc" }, remarkNode)));
}
export default Remark;
//# sourceMappingURL=Remark.js.map